/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const prefix = 'user';

export const allTenants = `${prefix}.allTenants`;

export const ENGLISH = {
    [allTenants]: 'All Tenants',
};
